import { useState, useCallback, useEffect } from 'react';
import AgentPortalError from 'errors/AgentPortalError';
import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client';

const UPDATE_BOOKING_DETAILS = gql`
  mutation UpdateBookingDetails($bookingReference: String!, $additionalDetails: [InputAdditionalDetails]) {
    updateAdditionalDetails(bookingReference: $bookingReference, additionalDetails: $additionalDetails) {
      reference
    }
  }
`;

export const useResolveExtrasConflicts = (options) => {
  const [updateExtrasMutation] = useMutation(UPDATE_BOOKING_DETAILS);
  const { refetchBooking, booking, hotelBooking } = options;
  const [error, setError] = useState(null);

  const [selectedExtras, setSelectedExtras] = useState({
    numberOfNights: false,
    guestCount: false
  });

  const [selectedExtrasLength, setSelectedExtrasLength] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const length = Object.values(selectedExtras).filter(Boolean).length;

    setSelectedExtrasLength(length);
  }, [selectedExtras]);

  const setUpdateExtra = useCallback(
    (extraName, extraStatus) => {
      setSelectedExtras({
        ...selectedExtras,
        [extraName]: extraStatus
      });
    },
    [selectedExtras]
  );

  const updateAllExtras = useCallback(async () => {
    const additionalDetails = [];

    const bookedHotel = booking.hotels.find((hotel) => !hotel.canceled);

    if (selectedExtras['numberOfNights']) {
      additionalDetails.push({
        key: 'number_of_nights',
        value: String(hotelBooking.duration),
        itemRefId: Number(bookedHotel.itemRef)
      });
    }

    if (selectedExtras['guestCount']) {
      additionalDetails.push({
        key: 'guest_count',
        value: String(hotelBooking.numberOfGuests),
        itemRefId: Number(bookedHotel.itemRef)
      });
    }

    if (!additionalDetails.length) {
      return;
    }

    setIsLoading(true);

    try {
      await updateExtrasMutation({
        variables: {
          bookingReference: booking.reference,
          additionalDetails: additionalDetails
        }
      });

      await refetchBooking();

      setSelectedExtras({
        numberOfNights: false,
        guestCount: false
      });

      setIsLoading(false);
    } catch (err) {
      setError(err);
    }
  }, [selectedExtras, booking, hotelBooking, updateExtrasMutation, refetchBooking]);

  if (error) {
    throw new AgentPortalError(error);
  }

  return {
    setUpdateExtra,
    updateAllExtras,
    isLoading,
    selectedExtras,
    selectedExtrasLength
  };
};
